export default __webpack_public_path__ + "static/char-thumb-46-0735aaa9de31563d99403c92f0b97ca7.png";